import { createAsyncThunk } from '@reduxjs/toolkit';
import type StatusApi from 'api/StatusApi';
import { ActionType } from 'enums/ActionType';

export const createFetchDeploymentStatusThunk = (api: StatusApi) => {
  return createAsyncThunk(ActionType.FetchDeploymentStatus, async () => {
    return await api.fetchStatus();
  });
};
